import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Phone, MessageCircle } from 'lucide-react';

const vendedores = [
  {
    name: 'Nizar',
    phone: '+595 971 308910',
    whatsapp: '595971308910',
  },
  {
    name: 'Gisel',
    phone: '+595 975 863667',
    whatsapp: '595975863667',
  },
];

function Vendedores() {
  const { t } = useLanguage();

  return (
    <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      {/* Hero Section */}
      <div style={{
        background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
        padding: '80px 20px',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: 'radial-gradient(rgba(255,255,255,0.1) 1px, transparent 1px)',
          backgroundSize: '24px 24px',
        }} />
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '20px',
            backgroundColor: 'rgba(37, 211, 102, 0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 28px',
          }}>
            <MessageCircle size={36} color="#25D366" />
          </div>
          <h1 style={{
            fontSize: '44px',
            fontWeight: '700',
            color: 'white',
            marginBottom: '16px',
            letterSpacing: '-0.5px',
          }}>
            {t('vendedores')}
          </h1>
          <p style={{
            fontSize: '20px',
            color: '#94a3b8',
            maxWidth: '600px',
            margin: '0 auto',
            lineHeight: '1.6',
          }}>
            {t('vendedoresDesc')}
          </p>
        </div>
      </div>

      {/* Vendedores Cards */}
      <div style={{
        maxWidth: '900px',
        margin: '-60px auto 0',
        padding: '0 20px 80px',
        position: 'relative',
        zIndex: 10,
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '32px',
        }}>
          {vendedores.map((vendedor, index) => (
            <div
              key={index}
              style={{
                backgroundColor: 'white',
                borderRadius: '24px',
                padding: '40px 32px',
                boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                textAlign: 'center',
                transition: 'all 0.3s ease',
                cursor: 'default',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-6px)';
                e.currentTarget.style.boxShadow = '0 16px 40px rgba(0,0,0,0.12)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.08)';
              }}
            >
              {/* Grayscale Logo as Avatar */}
              <div style={{
                width: '120px',
                height: '120px',
                borderRadius: '50%',
                overflow: 'hidden',
                margin: '0 auto 24px',
                backgroundColor: '#f1f5f9',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '4px solid #e2e8f0',
              }}>
                <img
                  src="/logomain.png"
                  alt={vendedor.name}
                  style={{
                    width: '80%',
                    height: '80%',
                    objectFit: 'contain',
                    filter: 'grayscale(100%)',
                    opacity: 0.6,
                  }}
                />
              </div>

              {/* Name */}
              <h3 style={{
                fontSize: '24px',
                fontWeight: '700',
                color: '#1f2937',
                marginBottom: '8px',
              }}>
                {vendedor.name}
              </h3>

              {/* Phone */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                marginBottom: '28px',
              }}>
                <Phone size={16} color="#6b7280" />
                <span style={{
                  fontSize: '16px',
                  color: '#6b7280',
                  fontWeight: '500',
                }}>
                  {vendedor.phone}
                </span>
              </div>

              {/* WhatsApp Button */}
              <a
                href={`https://wa.me/${vendedor.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                  backgroundColor: '#25D366',
                  color: 'white',
                  padding: '14px 32px',
                  borderRadius: '14px',
                  fontSize: '16px',
                  fontWeight: '600',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 16px rgba(37, 211, 102, 0.35)',
                  width: '100%',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#20BD5A';
                  e.currentTarget.style.boxShadow = '0 8px 24px rgba(37, 211, 102, 0.45)';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#25D366';
                  e.currentTarget.style.boxShadow = '0 4px 16px rgba(37, 211, 102, 0.35)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                {t('messageOnWhatsApp')}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Vendedores;
